import { render, staticRenderFns } from "./storehouseManageList.vue?vue&type=template&id=3c2f5adc&scoped=true"
import script from "./storehouseManageList.vue?vue&type=script&lang=js"
export * from "./storehouseManageList.vue?vue&type=script&lang=js"
import style0 from "./storehouseManageList.vue?vue&type=style&index=0&id=3c2f5adc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2f5adc",
  null
  
)

export default component.exports